/*
 *   File : portfolio-holdings-card.js
 *   Author : https://evoqins.com
 *   Description : Portfolio Holdings card component
 *   Integrations : NA
 *   Version : 1.0.0
*/

const PortfolioHoldingsCard = ({ type, data, toggleXirr, handleCardClick }) => {

    return (
        <>
            {
                type === 1 &&
                <div className="e-bg-white e-border-0-5px-taupe-gray border-radius-16 padding-12px-top cursor-pointer"
                    onClick={handleCardClick}>
                    <div className="d-flex align-items-start justify-content-between position-relative pe-3 ">

                        <div className="d-flex gap-2 align-items-start">

                            <p className='ribbon-bg e-text-dark-gray e-alt-font e-font-12 e-font-weight-600 mb-2'>
                                {data.name}
                            </p>

                            {
                                data.active_sip &&
                                <span className='e-bg-bright-lavender border-radius-32  padding-2px-tb padding-6px-lr e-text-white e-alt-font e-font-10 e-font-weight-400'>
                                    SIP
                                </span>
                            }
                        </div>

                    </div>


                    <div className="d-flex flex-column row-gap-2 px-3 pb-3 ">
                        <div className='d-flex justify-content-between'>
                            <p className='mb-0 e-text-arsenic-light e-alt-font e-font-12 e-font-weight-600 line-height-16px'>
                                Current value
                            </p>
                            <span className='e-font-14 e-font-weight-600 e-text-dark-gray'>
                                {data.current_amount_text}
                            </span>
                        </div>
                        <div className='d-flex justify-content-between'>
                            <p className='mb-0 e-text-arsenic-light e-alt-font e-font-12 e-font-weight-600 line-height-16px'>
                                {toggleXirr ? " XIRR Returns" : "Absolute Returns"}
                            </p>

                            <p className={`${data.returns_amount > 0 ? "e-text-green-crayola" : data.returns_amount < 0 ? "e-text-carmine-pink" : "e-text-smoky-black"}  mb-0 e-alt-font e-font-14 e-font-weight-600 line-height-20px`}>
                                {data.returns_amount_text}
                                {
                                    toggleXirr ?
                                        <span className={`${data.xirr > 0 ? "e-text-green-crayola" : data.xirr < 0 ? "e-text-carmine-pink" : "e-text-smoky-black"} e-font-weight-400 e-font-12`}>({data.xirr_text})</span>
                                        :
                                        <span className={`${data.returns_percentage > 0 ? "e-text-green-crayola" : data.returns_percentage < 0 ? "e-text-carmine-pink" : "e-text-smoky-black"} e-font-weight-400 e-font-12`}>({data.returns_percentage_text})</span>
                                }
                            </p>
                        </div>
                        <div className="d-flex flex-column gap-1">
                            <span className='e-text-arsenic-light e-alt-font e-font-12 e-font-weight-400 line-height-16px'>
                                Achieved
                            </span>
                            <div className="d-flex align-items-center gap-1">
                                <div className="progress flex-fill h-6px e-bg-sky-mist" role="progressbar" aria-label="Basic example" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100">
                                    <div className="progress-bar e-bg-line-gradient" style={{ width: `${data.achieved}%` }}></div>
                                </div>
                                <span className='e-text-arsenic-light e-alt-font e-font-12 e-font-weight-400 line-height-16px'>{data.achieved_text}</span>
                            </div>
                        </div>
                    </div>
                </div>
            }

            {
                type == 2 &&
                <div className="e-bg-white e-border-0-5px-taupe-gray border-radius-16 padding-12px-top cursor-pointer"
                    onClick={handleCardClick}>
                    <div className="d-flex align-items-start justify-content-between position-relative pe-3 ">

                        <div className="d-flex gap-2 align-items-start">

                            <p className='ribbon-bg e-text-dark-gray e-alt-font e-font-12 e-font-weight-600 mb-2'>
                                {/* 6 Year - Aggressive */}
                                {data.name}
                            </p>

                            {
                                data.sip_available &&
                                <span className='e-bg-bright-lavender border-radius-32  padding-2px-tb padding-6px-lr e-text-white e-alt-font e-font-10 e-font-weight-400'>
                                    SIP
                                </span>
                            }
                        </div>

                    </div>


                    <div className="d-flex flex-column row-gap-2 px-3 pb-3 ">
                        {/* <span className='e-text-custom-blue e-alt-font e-font-14 e-font-weight-600 line-height-20px'>
                            Smart Growth
                        </span> */}
                        <div className='d-flex justify-content-between'>
                            <p className='mb-0 e-text-arsenic-light e-alt-font e-font-12 e-font-weight-600 line-height-16px'>
                                Current value
                            </p>
                            <span className='e-font-14 e-font-weight-600 e-text-dark-gray'>
                                {data.current_amount_text}
                            </span>
                        </div>
                        <div className='d-flex justify-content-between'>
                            <p className='mb-0 e-text-arsenic-light e-alt-font e-font-12 e-font-weight-600 line-height-16px'>
                                {toggleXirr ? " XIRR Returns" : "Absolute Returns"}
                            </p>

                            <p className={`${data.returns_amount > 0 ? "e-text-green-crayola" : data.returns_amount < 0 ? "e-text-carmine-pink" : "e-text-smoky-black"}  mb-0 e-alt-font e-font-14 e-font-weight-600 line-height-20px`}>
                                {data.returns_amount_text}
                                {
                                    toggleXirr ?
                                        <span className={`${data.xirr > 0 ? "e-text-green-crayola" : data.xirr < 0 ? "e-text-carmine-pink" : "e-text-smoky-black"} e-font-weight-400 e-font-12`}>({data.xirr_text})</span>
                                        :
                                        <span className={`${data.returns_percentage > 0 ? "e-text-green-crayola" : data.returns_percentage < 0 ? "e-text-carmine-pink" : "e-text-smoky-black"} e-font-weight-400 e-font-12`}>({data.returns_percentage_text})</span>
                                }
                            </p>
                        </div>
                    </div>
                </div>
            }

            {
                type === 3 &&
                <div className="e-bg-white e-border-0-5px-taupe-gray border-radius-16 padding-12px-top cursor-pointer"
                    onClick={handleCardClick}>
                    <div className="d-flex align-items-start justify-content-between gap-1 position-relative px-3">
                        <div className='d-flex gap-2 align-items-start flex-wrap'>
                            <div className="e-bg-white border-radius-6 e-border-1px-solid-bright-gray-dark p-1">
                                <img src={data.image}
                                    alt={"fund logo"}
                                    width={32}
                                    height={32}
                                    className='e-fund-card-banner object-fit-contain border-radius-6' />
                            </div>
                            <p className='e-text-truncate  col-8 mb-0 e-text-dark-gray e-alt-font e-font-14 e-font-weight-600'>
                                {data.fund_name}
                            </p>

                        </div>
                        {
                            data.active_sip &&
                            <span className='e-bg-bright-lavender border-radius-32  padding-2px-tb padding-6px-lr e-text-white e-alt-font e-font-10 e-font-weight-400'>
                                SIP
                            </span>
                        }

                    </div>

                    <div className="d-flex flex-column row-gap-2 p-3 pt-2">
                        <div className='d-flex justify-content-between'>
                            <p className='mb-0 e-text-arsenic-light e-alt-font e-font-12 e-font-weight-600 line-height-16px'>
                                Current value
                            </p>
                            <span className=' e-alt-font e-font-14 e-font-weight-600 e-text-dark-gray'>
                                {data.current_amount_text}
                            </span>
                        </div>
                        <div className='d-flex justify-content-between'>
                            <p className='mb-0 e-text-arsenic-light e-alt-font e-font-12 e-font-weight-600 line-height-16px'>
                                {toggleXirr ? " XIRR Returns" : "Absolute Returns"}
                            </p>

                            <p className={`${data.returns_amount > 0 ? "e-text-green-crayola" : data.returns_amount < 0 ? "e-text-carmine-pink" : "e-text-smoky-black"}  mb-0 e-alt-font e-font-14 e-font-weight-600 line-height-20px`}>
                                {data.returns_amount_text}
                                {
                                    toggleXirr ?
                                        <span className={`${data.xirr > 0 ? "e-text-green-crayola" : data.xirr < 0 ? "e-text-carmine-pink" : "e-text-smoky-black"} e-font-weight-400 e-font-12`}>({data.xirr_text})</span>
                                        :
                                        <span className={`${data.returns_percentage > 0 ? "e-text-green-crayola" : data.returns_percentage < 0 ? "e-text-carmine-pink" : "e-text-smoky-black"} e-font-weight-400 e-font-12`}>({data.returns_percentage_text})</span>
                                }
                            </p>
                        </div>
                    </div>
                </div>
            }
            {
                type === 4 &&
                <div className="e-bg-lotion-light  border-radius-16 padding-12px-top cursor-pointer padding-12px-all">
                    <div className="d-flex align-items-start justify-content-between gap-1 position-relative ">
                        <div className="d-flex gap-2 align-items-start">
                            <div className='d-flex gap-2 align-items-start flex-wrap'>
                                <div className="e-bg-white border-radius-6 e-border-1px-solid-bright-gray-dark p-1">
                                    <img src={data.image}
                                        alt={"fund logo"}
                                        width={32}
                                        height={32}
                                        className='e-fund-card-banner object-fit-contain border-radius-6' />
                                </div>
                                <p className='e-text-truncate  col-8 mb-0 e-text-dark-gray e-alt-font e-font-14 e-font-weight-600'>
                                    {data.name}
                                </p>

                            </div>
                        </div>
                    </div>

                    <div className="d-flex flex-column row-gap-1 pt-2 px-1">
                        <div className='d-flex justify-content-between'>
                            <p className='mb-0 e-text-arsenic-light e-alt-font e-font-12 e-font-weight-600 line-height-16px'>
                                Current value
                            </p>
                            <span className=' e-alt-font e-font-14 e-font-weight-600 e-text-dark-gray'>
                                {data.current_amount_text}
                            </span>
                        </div>
                        <div className='d-flex justify-content-between'>
                            <p className='mb-0 e-text-arsenic-light e-alt-font e-font-12 e-font-weight-600 line-height-16px'>
                                {toggleXirr ? " XIRR Returns" : "Absolute Returns"}
                            </p>

                            <p className={`${data.returns_amount > 0 ? "e-text-green-crayola" : data.returns_amount < 0 ? "e-text-carmine-pink" : "e-text-smoky-black"}  mb-0 e-alt-font e-font-14 e-font-weight-600 line-height-20px`}>
                                {data.returns_amount_text}
                                {
                                    toggleXirr ?
                                        <span className={`${data.xirr > 0 ? "e-text-green-crayola" : data.xirr < 0 ? "e-text-carmine-pink" : "e-text-smoky-black"} e-font-weight-400 e-font-12`}>
                                            {/* ({data.xirr_text}) */}
                                        </span>
                                        :
                                        <span className={`${data.returns_percentage > 0 ? "e-text-green-crayola" : data.returns_percentage < 0 ? "e-text-carmine-pink" : "e-text-smoky-black"} e-font-weight-400 e-font-12`}>({data.returns_percentage_text})</span>
                                }
                            </p>
                        </div>
                    </div>
                </div>
            }

        </>
    )
};

export default PortfolioHoldingsCard;